var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLights = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 1634 2562",
  ref: ref
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "lights_svg__a",
  d: "M0 0h1634v2562H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "lights_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lights_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FEBB12",
  fillRule: "nonzero",
  d: "M580.338 1821.596l-139.704 693.666s3.18 19.384 166.049 19.384 179.81-20.344 179.81-20.344l-144.43-692.706h-61.725zm578.385 0l-139.704 693.666s3.18 19.384 166.049 19.384 179.811-20.344 179.811-20.344l-144.439-692.706h-61.717z",
  mask: "url(#lights_svg__b)",
  opacity: 0.2
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLights);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lights.06ac1c7656dffcd492950e7ab1fa5ee6.svg";